module.exports = __webpack_public_path__ + "img/UBER-EATS.211ac120.webp";